import React, { useState, useEffect } from "react";
import { apiPost, apiPut } from "../../API/Api_Url";
import { toast } from "react-toastify";
import { FaArrowLeft } from "react-icons/fa";

function ContractorUpdateBidModel({
    SelectedBid,
    isOpen,
    onClose,
    GetAllAssignRequirement,
    setExpandedJob
}) {
    const [BidAmount, setBidAmount] = useState("");
    const [Note, setNote] = useState("");
    const [IsLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (SelectedBid) {
            setBidAmount(SelectedBid?.BidAmount || "");
            setNote(SelectedBid?.Note || "");
        }
    }, [SelectedBid]);

    const handleSubmit = async () => {
        let newErrors = {};
        if (!BidAmount) newErrors.BidAmount = "BidAmount is required";
        if (!Note) newErrors.Note = "Note is required";

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        try {
            setIsLoading(true);
            const payload = {
                BidAmount: Number(BidAmount),
                Note,
            };

            const response = await apiPut(`api/contractor/UpdateRequirementBid/${SelectedBid?._id}`, payload);

            if (response?.data) {
                toast.success(response?.message || "Bid updated successfully!");
                onClose();
                setExpandedJob(null);
                GetAllAssignRequirement();
            } else {
                toast.error(response?.message || "Failed to update bid");
            }
        } catch (error) {
            console.error("Error updating bid:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-lg p-6 max-w-2xl w-full overflow-y-auto max-h-[90vh]">
                <div className="flex items-center mb-6 border-b pb-3">
                    <FaArrowLeft
                        className="mr-3 cursor-pointer text-gray-600 hover:text-gray-800 transition"
                        onClick={onClose}
                    />
                    <h2 className="text-2xl font-bold text-gray-800">
                        Update Bid
                    </h2>
                </div>
                <div className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
                        <div>
                            <label className="text-sm font-medium text-gray-600">
                                Proposed Price (₹)
                            </label>
                            <input
                                type="number"
                                value={BidAmount}
                                onChange={(e) => setBidAmount(e.target.value)}
                                className="w-full border rounded-lg px-3 py-2"
                            />
                            {errors.BidAmount && (
                                <p className="text-red-500 text-sm mt-1">{errors.BidAmount}</p>
                            )}
                        </div>
                        <div className="md:col-span-2">
                            <label className="text-sm font-medium text-gray-600">Note</label>
                            <textarea
                                value={Note}
                                onChange={(e) => setNote(e.target.value)}
                                rows={4}
                                className="w-full border rounded-lg px-3 py-2"
                            />
                            {errors.Note && (
                                <p className="text-red-500 text-sm mt-1">{errors.Note}</p>
                            )}
                        </div>
                    </div>
                </div>

                <div className="mt-8 flex justify-end gap-4 border-t pt-4">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 border rounded-lg hover:bg-gray-100 transition"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={IsLoading}
                        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                    >
                        {IsLoading ? "Updating..." : "Update Bid"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ContractorUpdateBidModel;
